var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentNewIconLatest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1996 10.3999V15.7332M15.1996 10.9332H17.3329V12.5332M15.1996 15.1999H17.3329V13.5999M5.59961 9.3332V5.59987C5.59961 5.01077 6.07717 4.5332 6.66628 4.5332H15.1996L18.3996 7.7332V9.3332M5.59961 16.7999V18.3999C5.59961 18.989 6.07717 19.4665 6.66628 19.4665H17.3329C17.922 19.4665 18.3996 18.989 18.3996 18.3999V16.7999M6.66628 10.9332V15.1999H7.73294C8.32205 15.1999 8.79961 14.7223 8.79961 14.1332V11.9999C8.79961 11.4108 8.32205 10.9332 7.73294 10.9332H6.66628ZM10.9329 11.9999V14.1332C10.9329 14.7223 11.4105 15.1999 11.9996 15.1999C12.5887 15.1999 13.0663 14.7223 13.0663 14.1332V11.9999C13.0663 11.4108 12.5887 10.9332 11.9996 10.9332C11.4105 10.9332 10.9329 11.4108 10.9329 11.9999Z",
    stroke: "#333333",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentNewIconLatest);
export default __webpack_public_path__ + "static/media/DocumentNewIconLatest.6a49937681a913b8ed53b3239814d732.svg";
export { ForwardRef as ReactComponent };